import { getRuleOperator, resolveRuleColumnType } from './rule-meta'
import { isActiveRule, isEmptyRuleValue, isValuelessOperator } from './rule-utils'
import type { RuleCondition, RuleGroupState, SystemParamField } from './rules'
import type { GridFilterOperator } from '@zoryn/components/grid'

let ruleIdSeq = 0

export function createRuleId(prefix = 'r') {
  ruleIdSeq += 1
  return `${prefix}_${ruleIdSeq}`
}

export function createRuleCondition(field: SystemParamField): RuleCondition {
  const type = resolveRuleColumnType(field.columnType)
  return {
    id: createRuleId('cond'),
    field: field.field,
    operator: type === 'number' || type === 'date' ? 'eq' : type === 'switch' ? 'eq' : 'like',
    type,
    value: type === 'switch' ? false : null,
    operatorList: getRuleOperator(type),
    logic: 'and',
    dataSource: field.dataSource,
  }
}

export function createRuleGroup(field?: SystemParamField): RuleGroupState {
  const group: RuleGroupState = {
    id: createRuleId('group'),
    logic: 'and',
    groupLogic: 'or',
    conditions: [],
  }
  if (field?.field) {
    group.conditions.push(createRuleCondition(field))
  }
  return group
}

export function ensureDefaultRuleGroups(
  groups: RuleGroupState[],
  field?: SystemParamField
) {
  if (groups.length > 0) {
    return groups
  }
  if (!field?.field) {
    return groups
  }
  groups.push(createRuleGroup(field))
  return groups
}

export function hasActiveRuleGroups(groups: RuleGroupState[]) {
  return groups.flatMap((group) => group.conditions).some(isActiveRule)
}

export function isActiveColumnMenuRule(operator: GridFilterOperator, value: unknown) {
  if (isValuelessOperator(operator)) {
    return true
  }
  return !isEmptyRuleValue(value)
}
